import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { getValidationSchema } from '../../util/helpers/getValidationSchema';
import useApplicationUid from '../../hooks/useApplicationUid';
import { IRA_ACCOUNT_TYPES } from '../../util/constants';
import { FormWrap } from '../FormContainer/FormContainer';
import useCustodianAccountTypeDispatch from '../../hooks/useCustodianAccountTypeDispatch';
import { parseEnumType } from '../../util/helpers/enumMappers';
import useIraApplicationFundingData from '../../hooks/useApplicationIraFundingData';
import Back from '../Buttons/Back';
import { ModalHeading } from '../Modal';
import Select from '../Fields/Select';
import OnBoardingCta from '../OnBoarding/OnBoardingCta';

const CustodianIraType = ({ handleNext, handleBack }) => {
  const { t } = useTranslation();
  const { ApplicationUid } = useApplicationUid();
  const { custodianAccountTypeDispatch } = useCustodianAccountTypeDispatch();
  const { IraApplicationFundingResponse } = useIraApplicationFundingData();
  const { CustodianAccountType } = IraApplicationFundingResponse;

  const formValidationSchema = Yup.object({
    ...getValidationSchema({
      fields: ['AccountType'],
    }),
  });

  const { handleSubmit, control } = useForm({
    resolver: yupResolver(formValidationSchema),
    defaultValues: {
      AccountType: {
        value: CustodianAccountType
          ? parseEnumType(IRA_ACCOUNT_TYPES, CustodianAccountType)
          : IRA_ACCOUNT_TYPES[0],
        label: CustodianAccountType
          ? parseEnumType(IRA_ACCOUNT_TYPES, CustodianAccountType)
          : IRA_ACCOUNT_TYPES[0],
      },
    },
  });

  const onSubmit = ({ AccountType }) => {
    custodianAccountTypeDispatch({
      ApplicationUid,
      params: {
        iRAAccountType: AccountType?.value,
      },
      defaultValues: {
        iRAAccountType: parseEnumType(IRA_ACCOUNT_TYPES, CustodianAccountType),
      },
      onSuccess: handleNext,
    });
  };

  const options = IRA_ACCOUNT_TYPES.map((item) => ({
    value: item,
    label: item,
  }));

  return (
    <>
      {handleBack && (
        <Back
          onClick={() => {
            handleBack();
          }}
        />
      )}

      <ModalHeading mb={32}>{t('iraCustodian.type.title')}</ModalHeading>

      <FormWrap>
        <Controller
          control={control}
          render={({ field, fieldState }) => (
            <Select
              label={t('fields.labels.iraType')}
              options={options}
              {...field}
              {...fieldState}
              autoFocus
            />
          )}
          name="AccountType"
        />

        <OnBoardingCta type="submit" onClick={handleSubmit(onSubmit)} />
      </FormWrap>
    </>
  );
};

CustodianIraType.propTypes = {
  handleNext: PropTypes.func,
  handleBack: PropTypes.func,
};

export default CustodianIraType;
